import { useState } from "react";
import { connect } from "react-redux";
import { bool, func, number, shape, string } from "prop-types";
import Modal from "@shared/v2/Modal/Modal";
import Button from "@shared/v2/Button/Button";
import { Spinner } from "@shared/v2/Icomoon";
import Alert from "@shared/v2/Alert/Alert";
import { submitBlueprintAsThunk } from "../actions/thunks";
import { SubmitReqState } from "../actions/creators";
import { mapToContactPayload } from "../model/ConactOptions";
import SellerContactInformation from "./SellerContactInformation";
import SuccessMsg from "../component/SuccessMsg";

const PreContractBlueprintModal = ({
  isModalOpen,
  onHideHandlr,
  onSubmitBlueprintAsThunk,
  listingId,
  submitReqState,
  onSubmitReqState,
  uuid,
}) => {
  const [addSellers, setAddSellers] = useState(false);
  const [comments, setComments] = useState(null);
  const [sellers, setSellers] = useState([]);
  const [newSellers, setNewSellers] = useState([]);

  const onSubmit = async () => {
    onSubmitReqState({ isloading: true, isSucceed: false, isFailed: false, failureMsg: "" });

    const bluePrintData = {
      comment: comments,
      title_type: "pre-contract",
      seller_ids: sellers.map((item) => item.value) || [],
      new_sellers: mapToContactPayload(newSellers) || [],
    };
    await onSubmitBlueprintAsThunk(listingId, uuid, bluePrintData);
  };

  return (
    <Modal
      show={isModalOpen}
      onHide={onHideHandlr}
      dialogClassName="tw-max-w-[638px]"
      contentClassName="tw-w-full tw-h-full tw-px-[22px]"
      className="tw-flex tw-justify-center tw-items-center"
      closeButton
    >
      <Modal.Header className="tw-px-[10px]" title="Open Title with Blueprint" closeButton />

      <Modal.Body className="tw-mb-32px tw-max-h-[70vh] tw-px-[10px] tw-overflow-auto">
        {!submitReqState?.isloading && !submitReqState?.isSucceed && !submitReqState?.isFailed && (
          <SellerContactInformation
            setAddSellers={setAddSellers}
            addSellers={addSellers}
            setComments={setComments}
            comments={comments}
            sellers={sellers}
            setSellers={setSellers}
            newSellers={newSellers}
            setNewSellers={setNewSellers}
          />
        )}
        {submitReqState?.isloading && (
          <>
            <div className="tw-border-solid tw-bg-[#F7F9FC] tw-border-neutral-gray-10 tw-h-[216px] tw-w-[552px] tw-mt-[24px] !tw-p-[11px] tw-border tw-rounded-[12px]">
              <Spinner size="xxl" className="tw-animate-spin tw-mx-auto tw-block tw-relative tw-top-1/2" />
            </div>
          </>
        )}
        {submitReqState?.isSucceed && <SuccessMsg />}
        {submitReqState?.isFailed && (
          <Alert
            containerClass="!tw-mt-[24px] !tw-p-[36px] !tw-text-center"
            variant="error"
            text={
              submitReqState?.failureMsg ||
              "There was an issue with submitting your form to Blueprint. Please reach out to support at (855) 427-4848 or start a new chat"
            }
          />
        )}
      </Modal.Body>
      <Modal.Footer
        className={`tw-px-[10px] tw-flex ${submitReqState?.isSucceed || submitReqState?.isFailed ? "tw-justify-center" : "tw-justify-between"} `}
      >
        {!submitReqState?.isloading && !submitReqState?.isSucceed && !submitReqState?.isFailed && (
          <>
            <Button size="medium" schema="tertiary" onClick={onHideHandlr}>
              Cancel
            </Button>
            <Button
              size="medium"
              onClick={onSubmit}
              disabled={addSellers || (sellers.length < 1 && newSellers.length < 1)}
            >
              Submit
            </Button>
          </>
        )}
        {(submitReqState?.isSucceed || submitReqState?.isFailed) && (
          <Button size="medium" onClick={onHideHandlr}>
            Got it!
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};
PreContractBlueprintModal.propTypes = {
  isModalOpen: bool,
  onHideHandlr: func,
  onSubmitBlueprintAsThunk: func.isRequired,
  onSubmitReqState: func,
  listingId: number.isRequired,
  uuid: string.isRequired,
  onShowBlueprintFailure: func,
  submitReqState: shape({ isloading: bool, isSucceed: bool, isFailed: bool, failureMsg: string }),
};

PreContractBlueprintModal.defaultProps = {
  isModalOpen: false,
  onShowBlueprintFailure: null,
  onSubmitReqState: null,
  onHideHandlr: () => {},
  submitReqState: { isloading: false, isSucceed: false, isFailed: false, failureMsg: "" },
};
const mapStateToProps = (state) => ({
  submitReqState: state.tdpTitleAndEscrowReducer.submitReqState,
  listingId: state.tdpDetailsReducer.headerDetails.listing_id,
  uuid: state.tdpDetailsReducer.uuid,
});

const mapDispatchToProps = (dispatch) => ({
  onSubmitBlueprintAsThunk: (listingId, uuid, data) =>
    dispatch(submitBlueprintAsThunk(listingId, uuid, data)),
  onSubmitReqState: (data) => dispatch(SubmitReqState(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(PreContractBlueprintModal);
